import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rx-applications-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: InputNumberComponent,
    },
  ],
})
export class InputNumberComponent implements ControlValueAccessor {
  @HostBinding('class.ng-invalid') @Input() error: string;

  @Input() hidePlusMinusIcons = false;
  @Input() help?: string;
  @Input() label: string;
  @Input() disabled = false;
  @Input() min = 1;
  @Input() max: number;
  @Input() allowEmpty = false;
  value = 0;

  @Output() inputBlur: EventEmitter<number> = new EventEmitter<number>();

  onChange = (value: number) => {
    /**/
  };

  onTouched = () => {
    /**/
  };

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: number): void {
    this.value = value;
  }

  add(): void {
    this.value = ++this.value;
    this.onChange(this.value);
  }

  subtract(): void {
    if (this.isAboveMin(this.value - 1)) {
      this.value = --this.value;
      this.onChange(this.value);
    }
  }

  checkMinimum(): void {
    if (this.isAboveMin() || (this.allowEmpty && this.value === null)) {
      this.onChange(this.value);
    } else {
      this.value = this.min;
      this.onChange(this.value);
    }
  }

  private isAboveMin(value = this.value): boolean {
    return value >= this.min;
  }

  onInputBlur() {
    this.inputBlur.emit(this.value);
  }
}
